import { MixpanelEventName, useAnalytics } from '@/app/utils/useAnalytics';
import { LoggedInAvatar } from '@/modules/LandingHeaderV2/components/LoggedInAvatar/LoggedInAvatar';
import { NavLink } from '@/modules/LandingHeaderV2/components/NavLink/NavLink';
import cx from 'classnames';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import styles from './NavDropdownLabelButton.module.scss';

interface NavDropdownLabelButtonProps {
  isSmallScreen: boolean;
  handleOnClick: () => void;
  to: string;
  label: React.ReactNode;
  testid?: string;
  isLoggedInDropdown?: boolean;
  userInitials?: string;
  trackEventName?: MixpanelEventName;
  isOrHasActiveLink?: boolean;
  isDropdownOpen?: boolean;
  onNavItemClick?: () => void;
}

export const NavDropdownLabelButton = ({
  isSmallScreen,
  handleOnClick,
  to,
  label,
  testid,
  trackEventName,
  isOrHasActiveLink,
  isLoggedInDropdown,
  userInitials,
  isDropdownOpen,
  onNavItemClick,
}: NavDropdownLabelButtonProps) => {
  const track = useAnalytics();
  const showLoggedInAvatar = isLoggedInDropdown && userInitials;

  return isSmallScreen ? (
    <button
      data-testid={`${testid}-nav-dropdown-button`}
      className={cx(styles.navDropdownButton, isOrHasActiveLink && styles.activeLink)}
      onClick={() => {
        trackEventName && track(trackEventName, {});
        handleOnClick();
      }}
    >
      <span className={styles.navDropdownLabel}>{label}</span>{' '}
      <div className={styles.chevron}>{isDropdownOpen ? <ExpandLess /> : <ExpandMore />}</div>
    </button>
  ) : (
    <NavLink
      to={to}
      testid={`${testid}-nav-dropdown-link`}
      className={cx(styles.navDropdownButton, isOrHasActiveLink && styles.activeLink)}
      trackEventName={trackEventName}
      onNavItemClick={onNavItemClick}
      label={
        <>
          <span className={styles.navDropdownLabel}>{label}</span>{' '}
          {showLoggedInAvatar && <LoggedInAvatar initials={userInitials} />}{' '}
          <div className={styles.chevron}>{isDropdownOpen ? <ExpandLess /> : <ExpandMore />}</div>
        </>
      }
    />
  );
};
